import "../../sass/components/Searchbox.scss";

export default function Searchbox({placeholder, onSearchChange, state, dispatch, dataTestid}) {
    return (
        <div className="searchbox">
            <input type="text"
                   className="form-control"
                   placeholder={placeholder}
                   onChange={onSearchChange}
                   value={state.searchValue}
                   data-testid={dataTestid}
            />
            <i className="far fa-search" data-testid={dataTestid+"_filter_icon"}></i>
        </div>
    );
}
